module.exports = __webpack_public_path__ + "img/footer_icon_install.5352c2fa.svg";